import Representation2d from './Representation2d';
import ShapeTypeEnum from './ShapeTypeEnum';
import apiSvgRepresentation2dSchema from '../../services/bimVisualizerApi/schema/representation2d/apiSvgRepresentation2dSchema'

export default class SvgRepresentation2d extends Representation2d {
    
    width: number | null = null;
    height: number | null = null;
    
    constructor(width: number | null, height: number | null, materialId: number | null) {
        super(ShapeTypeEnum.SvgSymbol, materialId);
        this.width = width;
        this.height = height;
    }
    
    static fromJSON(json: any): Representation2d {

        const parsed = apiSvgRepresentation2dSchema.parse(json);

        return new SvgRepresentation2d(parsed.width, parsed.height, parsed.materialId)
    } 
}